import React from 'react';
import { styled, useTheme } from '@mui/system';
import PropTypes from 'prop-types'; // Import PropTypes for type checking
import { appInsights } from '../../../auth/appInsight';
import { getStringProduct } from '../../../utils/utilityFunctions';

const Text = styled('p')(({ theme, padding, ...rest }) => ({
  fontFamily: rest.fontfamily || 'Poppins',
  fontStyle: 'normal',
  fontWeight: rest.fontweight || 400,
  fontSize: rest.fontsize || '14px',
  lineHeight: rest.lineheight || '21px',
  paddingRight: rest.paddingright || '10px',
  padding: padding || '0px',
  textAlign: rest.textalign || 'left',
  letterSpacing: '0.46px',
  whiteSpace: rest.whitespace || 'nowrap',
  width: rest.width || '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  margin: rest.margin || '0px',
  textTransform: rest.texttransform || '',
  [theme.breakpoints.down('sm')]: {
    margin: rest.smmargin || '0px 0px 0px 0px',
    fontSize: rest.smfontsize || '12px !important'
    // lineHeight: "20px",
  },
  [theme.breakpoints.up('xll')]: {
    fontSize: `${getStringProduct(1.25, rest.fontsize || '14px')} !important`,
    lineHeight: getStringProduct(1.25, rest.lineheight || '21px'),
    paddingRight: getStringProduct(1.25, rest.paddingright || '10px'),
    letterSpacing: getStringProduct(1.25, '0.46px'),
    margin: `${getStringProduct(1.25, rest.margin) || '0px'} !important`,
    width: getStringProduct(1.25, rest.width || '100%') 
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: `${getStringProduct(1.66, rest.fontsize || '14px')} !important`,
    lineHeight: getStringProduct(1.66, rest.lineheight || '21px'),
    paddingRight: getStringProduct(1.66, rest.paddingright || '10px'),
    letterSpacing: getStringProduct(1.66, '0.46px'),
    margin: `${getStringProduct(1.66, rest.margin) || '0px'} !important`,
    width: getStringProduct(1.66, rest.width || '100%') 
  },
  [theme.breakpoints.up('xl4')]: {
    fontSize: `${getStringProduct(2.46, rest.fontsize || '14px')} !important`,
    lineHeight: getStringProduct(2.46, rest.lineheight || '21px'),
    paddingRight: getStringProduct(2.46, rest.paddingright || '10px'),
    letterSpacing: getStringProduct(2.46, '0.46px'),
    margin: `${getStringProduct(2.46, rest.margin) || '0px'} !important`,
    width: getStringProduct(2.46, rest.width || '100%') 
  },
  color: rest.textcolor || theme.palette.text.primary
  // ...rest
}));

export const FreedomDialogTypography = (props) => {
  const { children, ...rest } = props;
  try {
    return <Text {...rest}>{children}</Text>;
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
    return null; // Ensure a component is always returned
  }
};
